module.exports = __webpack_public_path__ + "img/propertysupervise4.2f682779.png";